import Tooltip from "@material-ui/core/Tooltip";
import CheckIcon from "@material-ui/icons/Check";
import withStyles from "@material-ui/styles/withStyles";
import { maybe } from "@saleor/misc";
import { orderPath } from "@saleor/motherOrders/urls";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import { RemittanceRunnerOrders_remittanceOrders_edges_node } from "@saleor/remittanceRunner/types/RemittanceRunnerOrders";
import { SmopOrderStatusEnum } from "@saleor/types/globalTypes";
import React from "react";

interface RemittanceRunnerTblColMotherOrderProp {
  remittance: RemittanceRunnerOrders_remittanceOrders_edges_node;
  isOmiAdmin: boolean;
}

const TooltipWithArrow = withStyles(
  {
    tooltip: {
      "&:after": {
        borderColor: "transparent #2b3039 transparent transparent",
        borderStyle: "solid",
        borderWidth: 5,
        content: "' '",
        marginTop: -5,
        position: "absolute",
        right: "100%",
        top: "50%"
      },
      backgroundColor: "#002972",
      borderRadius: "6px",
      color: "ffff",
      fontSize: "1em",
      left: 20,
      marginLeft: 0,
      padding: "10px",
      position: "relative"
    }
  },
  { name: "TooltipWithArrow" }
)(Tooltip);

export const RemittanceRunnerTblColMotherOrder: React.FC<RemittanceRunnerTblColMotherOrderProp> = props => {
  const { remittance, isOmiAdmin } = props;
  const tblClasses = useTableStyles(props);

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>Mother Order</div>
      <div className={`${tblClasses.dataDisplay}`}>
        {maybe(() => remittance.orderCode) ? (
          <div
            onClick={() => {
              if (!isOmiAdmin) {
                window.open(orderPath(remittance.id));
              }
            }}
          >
            <div
              className={
                !isOmiAdmin
                  ? `${tblClasses.dataOrderCode} ${tblClasses.cursorHand}`
                  : `${tblClasses.dataOrderCode}`
              }
            >
              <div className={tblClasses.dataOrderCodeContainer}>
                <span className={tblClasses.dataOrderCode}>
                  {remittance.orderCode}
                </span>
                {remittance?.smopStatus === SmopOrderStatusEnum.COMPLETED && (
                  <TooltipWithArrow
                    id={`remittance-Tooltip`}
                    title="Completed"
                    placement="right"
                  >
                    <CheckIcon className={tblClasses.checkIcon} />
                  </TooltipWithArrow>
                )}
              </div>
            </div>
            <div className={`${tblClasses.dataTenantBrand}`}>
              {remittance?.subOrders[0].tenant.brand.name}
            </div>
          </div>
        ) : (
          <span>-----</span>
        )}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColMotherOrder;
